import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { PERMIT_TEMPLATE_FIELDS } from "../fragments/PermitTemplate";
import {
  GetMyRegistersByOrganizationId,
  GetMyRegistersByOrganizationIdVariables,
} from "./__generated__/GetMyRegistersByOrganizationId";
import { CORE_PROJECT_FIELDS } from "../fragments/project";
import { CORE_PERMIT_REGISTER_FIELDS } from "../fragments/PermitRegister";
import { CORE_ORGANIZATION_FIELDS } from "../fragments/organization";
import { CORE_PERMIT_TYPE_FIELDS } from "../fragments/PermitType";

export const GET_MY_REGISTERS_BY_ORGANIZATION_ID = gql`
  ${CORE_PROJECT_FIELDS}
  ${PERMIT_TEMPLATE_FIELDS}
  ${CORE_PERMIT_REGISTER_FIELDS}
  ${CORE_ORGANIZATION_FIELDS}
  ${CORE_PERMIT_TYPE_FIELDS}
  query GetMyRegistersByOrganizationId($organizationId: String!) {
    myRegistersByOrganizationId(organizationId: $organizationId) {
      ...CorePermitRegisterFields
      permitTypes {
        ...CorePermitTypeFields
        template {
          ...PermitTemplateFields
        }
      }
      project {
        ...CoreProjectFields
        organization {
          ...CoreOrganizationFields
        }
      }
    }
  }
`;

export function useLazyGetMyRegistersByOrganizationId() {
  const [getMyRegistersByOrganizationId, { loading, error, data }] = useLazyQuery<
    GetMyRegistersByOrganizationId,
    GetMyRegistersByOrganizationIdVariables
  >(GET_MY_REGISTERS_BY_ORGANIZATION_ID, {
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  return {
    getMyRegistersByOrganizationId,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
